export enum EForgotPasswordCasesUI {
  'RESET_PASSWORD'= 'RESET_PASSWORD',
  'RESEND_INVITATION' = 'RESEND_INVITATION',
}

export enum EForgotPasswordCasesDB {
  'PASSWORD_RESET_CODE_DELIVERED' = 'PASSWORD_RESET_CODE_DELIVERED',
  'INVITATION_RESEND' = 'INVITATION_RESEND',
}
